import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import { SliderState } from './Slider.state';
import { SliderHeader } from './slider-header/SliderHeader';
import { ButtonChevronIcon } from 'src/domains/layouts/shared/ScrollButtons.style';
import {
    ScrollLeft,
    SliderWrapper,
    Swiper,
    ScrollRight,
    SliderBox,
} from 'src/domains/casino/webview/CasinoGames/home-games/slider/Slider.style';
import { convertTitleToDataTest } from 'src/domains/casino/utils/utils';
import { useCommon } from 'src/domains/common/Common';
import { BreakpointsState } from 'src/domains/layouts/state/breakpointsState/BreakpointsState';

interface SliderPropsType {
    children: JSX.Element;
    className?: string;
    customHeader?: React.ReactNode;
    onViewAllClick?: () => void;
    title?: string | JSX.Element;
    withoutViewAll?: boolean;
    isHomePage?: boolean;
}

export const Slider = observer('Slider', (props: SliderPropsType) => {
    const { children, className, customHeader, onViewAllClick, title, withoutViewAll, isHomePage } = props;

    const common = useCommon();
    const breakpointsState = BreakpointsState.get(common);

    const [state] = React.useState(() => new SliderState());
    const { scrollLeftArrow, scrollRightArrow, goToLeft, goToRight, setRef } = state;

    const isDesktop = breakpointsState.tablet.isBiggerOrEq;
    const goLeftAvailable = scrollLeftArrow === true && isDesktop === true;
    const goRightAvailable = scrollRightArrow === true && isDesktop === true;

    const dataTest = convertTitleToDataTest(title ?? 'default');

    return (
        <SliderBox
            data-test={`slider-${dataTest}`}
            isHomePage={isHomePage}
        >
            {title !== undefined && (
                <SliderHeader
                    title={title}
                    onViewAllClick={onViewAllClick}
                    withoutViewAll={withoutViewAll}
                />
            )}

            {customHeader === undefined ? null : customHeader}

            <SliderWrapper key='slider-wrapper'>
                {goLeftAvailable && (
                    <ScrollLeft
                        isVisible={goLeftAvailable}
                        onClick={goToLeft}
                    >
                        <ButtonChevronIcon position='left' />
                    </ScrollLeft>
                )}

                <Swiper
                    className={className}
                    key='slider-swiper'
                    ref={setRef}
                >
                    {children}
                </Swiper>

                {goRightAvailable && (
                    <ScrollRight
                        isVisible={goRightAvailable}
                        onClick={goToRight}
                    >
                        <ButtonChevronIcon position='right' />
                    </ScrollRight>
                )}
            </SliderWrapper>
        </SliderBox>
    );
});
